import config from 'scoreboard/components/config'
import ScorecardNode from 'scoreboard/scorecards/scorecard-node'

/**
 * Returns whether threshold labels should be allowed on linear gauges
 *
 * @param {String} section
 * @param {ApiScorecardNode} sn
 */
function allowThresholdLabels (section, sn) {
	if (section === 'scorecards' && ScorecardNode.metricish(sn)) {
		let scoringType = config.scoringType(sn.scoringTypeId)
		// #48073 no thresholds option for custom text scoring types
		return !scoringType.isCustomText
	} else {
		return true
	}
}

export default allowThresholdLabels

allowThresholdLabels.__filename__ = 'dashboards/widgets/linear-gauge/allow-threshold-labels.js'
